export default __webpack_public_path__ + "static/media/Radiotherapy.258ab1cb.png";